<template>
  <div class="container">
    <h2 class="giftVoucher">Gift Voucher</h2>
    <div v-if="loading == true">
        <div class="loader"></div>
        <h2 class="loading">Loading...</h2>
    </div>

    <div class="content" id="content" v-if="VData.status == 'OK'">
      <div class="boxcontent">
        <span @click="closed()" class="close">&times;</span>
        <b-row>
          <b-col lg="6" sm="12">
            <img class="voucherImage" src="https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/Voucher_Sim_Park-scaled.png">
          </b-col>
          <b-col lg="6" sm="12">
            <p class="my-4 voucherTextMain">Thank you for purchasing a voucher! </p>
            <p class="my-4 voucherText">You will shortly recieve two emails. </p>
            <p class="my-4 voucherText">One being your payment recipt and one being your voucher. </p>
            <p class="my-4 voucherText" v-if="VData.email_rec == 'Y'">This voucher has been emailed to {{VData.rec_name}} ({{VData.rec_email}})</p>
            <p class="my-4 voucherCode">{{VData.voucher}}</p>
            <p class="my-4 voucherexpiry">Expiry date : {{VData.expiry_date}}</p>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Voucher Section -->
    <b-row v-if="loading == false">
        <!-- Golf Section -->
        <b-col v-for="(single, index) in golfInfo" :key="index" lg="6" sm="12">
            <div class="backImage" :class="{backImageCust :$route.query.code == '13' }" v-bind:style="{ 'background-image': 'url(' + single.image + ')' }"></div>
            <h2 class="titleText" v-html="single.title"></h2>
            <h2 class="moneyValue" v-bind:style="{ 'color': single.color  }">{{single.descript_title}}</h2>
            <p class="description" v-html="single.description"></p>
        </b-col>
        <!-- Flight Section -->
        <b-col v-for="(single, index) in flightInfo" :key="index" lg="6" sm="12">
            <div class="backImage" v-bind:style="{ 'background-image': 'url(' + single.image + ')' }"></div>
            <h2 class="titleText" v-html="single.title"></h2>
            <h2 class="moneyValue" v-bind:style="{ 'color': single.color  }">{{single.descript_title}}</h2>
            <p class="description" v-html="single.description"></p>
        </b-col>
        <!-- Race Section -->
        <b-col v-for="(single, index) in raceInfo" :key="index" lg="6" sm="12">
            <div class="backImage" v-bind:style="{ 'background-image': 'url(' + single.image + ')' }"></div>
            <h2 class="titleText" v-html="single.title"></h2>
            <h2 class="moneyValue" v-bind:style="{ 'color': single.color  }">{{single.descript_title}}</h2>
            <p class="description" v-html="single.description"></p>
        </b-col>
        <!-- Form details -->
        <b-col id="myForm" lg="6" sm="12">
          <h2 class="SectionTitle">Buyers Section</h2>
          <b-form ref="formdata">
          <b-form-group
            label="Name"
            label-for="input-lazy"
            class="mb-0 buyersName"
          >
            <b-form-input
              id="input-lazy"
              v-model="buyersName"
              lazy-formatter
              :formatter="formatter"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Phone Number"
            label-for="input-lazy"
            class="mb-0"
          >
            <b-form-input
              id="input-lazy"
              v-model="buyersPhone"
              lazy-formatter
              :formatter="formatter"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Email"
            label-for="input-lazy"
            class="mb-0"
          >
            <b-form-input
              id="input-lazy"
              v-model="buyersEmail"
              lazy-formatter
              :formatter="formatter"
            ></b-form-input>
          </b-form-group>
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value="true"
            unchecked-value="false"
            class="check"
          >
          <span class="gift">
            Recipient Details (Optional)
          </span>
          </b-form-checkbox>
          <div v-if="status != 'false'">
            <h2 class="SectionTitle receipentSection">Recipient Section</h2> 
            <b-form-group
              label="Name"
              label-for="input-lazy"
              class="mb-0"
            >
              <b-form-input
                id="input-lazy"
                v-model="recipientName"
                lazy-formatter
                :formatter="formatter"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Email"
              label-for="input-lazy"
              class="mb-0"
            >
              <b-form-input
                id="input-lazy"
                v-model="recipientEmail"
                lazy-formatter
                :formatter="formatter"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="eGift Message"
              label-for="input-lazy"
              class="mb-0"
            >
            <!-- :state="giftMessage.length >= 10 && giftMessage.length <= 200" -->
              <b-form-textarea
                id="textarea"
                v-model="giftMessage"
                rows="8"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-checkbox
              id="checkbox-2"
              v-model="recieveEmailstatus"
              name="checkbox-2"
              value="Y"
              unchecked-value="N"
              class="check"
            >
              <span class="gift">
                Do you want the recipient to receive an email?
              </span>
            </b-form-checkbox>
          </div>
          </b-form>
          <!-- money sldier -->
          <template v-if="$route.query.code == '13' || info.title.includes('Custom Amount Gift')">
            <div class="moneyValue">
              <veeno 
                :handles = "[25]" 
                v-model="sliderValue"
                :step = "5"
                :range = "{ 
                  'min': [  0 ],
                  '30%': [  100, 10 ],  // from 4000, slide by stepping
                  '50%': [  250, 25 ],  // from 4000, slide by stepping
                  '70%': [  1000, 50 ],
                  'max': [ 2000 ]
                }"
              />
              {{ sliderValue }}
              <span class="slidervalue"> £ <span v-if="sliderValue == 0">{{ $route.query.price }}</span> {{ sliderValue }}</span>
            </div>
          </template>
          <div class="buttonSec">
            <template v-if="isIpad(true)">
              <template v-if="buyersName != '' && buyersPhone != '' && buyersEmail.includes('@')">
                <button v-b-modal.modal-1 class="submit" @click="getStripeMob()">Buy Now</button>
              </template>
              <template v-else>
                <button class="submit dis" disabled>Buy Now</button>
              </template>
            </template>
            <template v-else>
              <template v-if="buyersName != '' && buyersPhone != '' && buyersEmail.includes('@')">
                <button v-b-modal.modal-1 class="submit" @click="getStripe()">Buy Now</button>
              </template>
              <template v-else>
                <button class="submit dis" disabled>Buy Now</button>
              </template>
            </template>
            <!-- <stripe-checkout
              ref="checkoutRef"
              mode="payment"
              :pk="publishableKey"
              :line-items="lineItems"
              :success-url="successURL"
              :cancel-url="cancelURL"
              @loading="v => loading = v"
            />
            <button class="submit"  @click="submit">Buy now</button> -->
          </div>
        </b-col>
    </b-row>
  </div>
</template>


<script>
import veeno from 'veeno'
import 'nouislider/distribute/nouislider.min.css';  

import axios from 'axios'
import * as CryptoJS from 'crypto-js';
export default {
  name: 'Single Voucher',
  components: {
    veeno,
  },
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      acf: [],
      golfInfo:[],
      raceInfo:[],
      flightInfo:[],
      simInfo:[],
      info: [],
      buyersName: '',
      buyersPhone: '',
      buyersEmail: '',
      recipientName: '',
      recipientEmail: '',
      giftMessage: '',
      recieveEmailstatus: 'N',
      cryptoAES: CryptoJSAesJson,
      urlData: '',
      loading: true,
      status: 'false',
      versionType: '',
      personType: '',
      quantity: '',
      sliderValue: '',
      value: '',
      statusData:'',
      VData: {},
      close: 'N',
      payWindow: {}
    };
  },
  methods: {
    closed() {
      this.close = 'Y'
       document.getElementById("content").style.display = "none";
    },
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    isIpad() {
        if( screen.width <= 750 ) {
            return true;
        }
        else {
            return false;
        }
    },
    getvoucherContentGolf: function() {
        let arr = [];
        // console.log("arr")
        // console.log(arr)
        this.golfInfo = arr;

        this.acf.acf.vouchers_golf.forEach((value) => {
            if (this.$route.query.code == value.num) {
                arr.push(value);
                // console.log(value);
            } else {
                // console.log("error")
            }
        });
        // output.innerHTML = slider;

        // slider.oninput = function() {
        //   output.innerHTML = this.value;
        // }
    },
    getvoucherContentFlight: function() {
        let arr = [];
        // console.log("arr")
        // console.log(arr)
        this.flightInfo = arr;

        this.acf.acf.vouchers_flight.forEach((value) => {
            if (this.$route.query.code == value.num) {
                arr.push(value);
                // console.log(value);
            } else {
                // console.log("error")
            }
        });
    },
    getvoucherContentRace: function() {
        let arr = [];
        // console.log("arr")
        // console.log(arr)
        this.raceInfo = arr;

        this.acf.acf.vouchers_race.forEach((value) => {
            if (this.$route.query.code == value.num) {
                arr.push(value);
                // console.log(value);
            } else {
                // console.log("error")
            }
        });
    },

    payStripe(payOpts) {
        console.log('IN')
        if (this.golfInfo.length > 0) {
          this.info = this.golfInfo[0]
          this.versionType = 'G'
          this.personType = ''
          this.quantity = '1'
        } else if(this.raceInfo.length > 0) {
          this.info = this.raceInfo[0]
          this.versionType = 'R'
          this.personType = ''
          this.quantity = '1'
          // if (this.info.title.includes('Adults')) {
          //   this.personType = 'A'
          // } else {
          //   this.personType = 'J'
          // }
        }else if(this.flightInfo.length > 0) {
          this.info = this.flightInfo[0]
          this.versionType = 'F'
          this.personType = ''
          this.quantity = '1'
        }else if(this.simInfo.length > 0) {
          this.info = this.simInfo[0]
          this.versionType = 'A'
          this.personType = ''
          this.quantity = '1'
        }
        let salesDes = this.info.send_descript.replace(/(<([^>]+)>)/ig, '').replace(/'''/ig, '');
        // console.log("this.salsesDesscription")
        // console.log(salesDes)
        this.salesDescription = salesDes;
        if (this.sliderValue == '') {
          if (this.$route.query.code == '13') {
            const feeAmnt = parseFloat(this.$route.query.price).toFixed(2).split('.');
            const feeUnit = parseInt(feeAmnt[0]) * 100;
            const feeCent = parseInt(feeAmnt[1]);
            console.log(feeUnit, feeCent)
            let emailAddr = this.buyersEmail;

            let sktMsg = '';
            sktMsg += this.buyersName + '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += this.buyersPhone + '~';
            sktMsg += this.buyersEmail + '~';
            sktMsg += this.$route.query.price + '~';
            // sktMsg += '1' + '~';
            sktMsg += this.quantity + '~';
            sktMsg += this.recipientName + '~';
            sktMsg += this.recipientEmail + '~';
            sktMsg += this.giftMessage + '~';
            sktMsg += this.recieveEmailstatus + '~';
            sktMsg += this.versionType + '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += this.personType + '~'; 
            sktMsg += this.salesDescription + '~';

            this.stMsg = sktMsg
            console.log( "this.stMsg")
            console.log( this.stMsg)


            const payObj = {
              'line_items': {
                'name': this.buyersName,
                'email': this.buyersEmail,
                'phone': this.buyersPhone,
                'description': this.info.title,
                'club_logo': 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/SimPark.png',
                'amount' : (feeUnit + feeCent),
                'currency': 'gbp',
                'quantity': 1,
              },
              'client_reference_id': JSON.stringify({user: 'VOUCHER'}),
              'customer_email': emailAddr,
              'success_url': 'https://ocs.golf/voucher-success/',
              'cancel_url': 'https://ocs.golf/voucher-fail/',
              'club_code': '2000029000',
              // 'club_code': '1000000001',
              'fac_mid': '0001',
              'fromweb': 'y',
              'book_string': this.stMsg,
              'book_string2': '',
              'payment_type': 'V',
            };

            if (typeof payOpts == 'object') {
              for (const i in payOpts)
                payObj[i] = payOpts[i];
            }

            return payObj
          } else {
            const feeAmnt = parseFloat(this.info.money_value).toFixed(2).split('.');
            const feeUnit = parseInt(feeAmnt[0]) * 100;
            const feeCent = parseInt(feeAmnt[1]); 
            // const feeAmnt = parseFloat('1').toFixed(2).split('.');
            // const feeUnit = parseInt(feeAmnt[0]) * 100;
            // const feeCent = parseInt(feeAmnt[1]);
            console.log(feeUnit, feeCent)
            let emailAddr = this.buyersEmail;

            let sktMsg = '';
            sktMsg += this.buyersName + '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += this.buyersPhone + '~';
            sktMsg += this.buyersEmail + '~';
            sktMsg += this.info.money_value + '~';
            // sktMsg += '1' + '~';
            sktMsg += this.quantity + '~';
            sktMsg += this.recipientName + '~';
            sktMsg += this.recipientEmail + '~';
            sktMsg += this.giftMessage + '~';
            sktMsg += this.recieveEmailstatus + '~';
            sktMsg += this.versionType + '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += '~';
            sktMsg += this.personType + '~'; 
            sktMsg += this.salesDescription + '~';

            this.stMsg = sktMsg
            console.log("this.stMsg")
            console.log(this.stMsg)

            const payObj = {
              'line_items': {
                'name': this.buyersName,
                'email': this.buyersEmail,
                'phone': this.buyersPhone,
                'description': this.info.title,
                'club_logo': 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/SimPark.png',
                'amount' : (feeUnit + feeCent),
                'currency': 'gbp',
                'quantity': 1,
              },
              'client_reference_id': JSON.stringify({user: 'VOUCHER'}),
              'customer_email': emailAddr,
              'success_url': 'https://ocs.golf/voucher-success/',
              'cancel_url': 'https://ocs.golf/voucher-fail/',
              'club_code': '2000029000',
              // 'club_code': '1000000001',
              'fac_mid': '0001',
              'fromweb': 'y',
              'book_string': this.stMsg,
              'book_string2': '',
              'payment_type': 'V',
            };

            if (typeof payOpts == 'object') {
              for (const i in payOpts)
                payObj[i] = payOpts[i];
            }

            return payObj
          }
        } else {
          const feeAmnt = parseFloat(this.sliderValue).toFixed(2).split('.');
          const feeUnit = parseInt(feeAmnt[0]) * 100;
          const feeCent = parseInt(feeAmnt[1]);
          console.log(feeUnit, feeCent)
          let emailAddr = this.buyersEmail;

          let sktMsg = '';
          sktMsg += this.buyersName + '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += this.buyersPhone + '~';
          sktMsg += this.buyersEmail + '~';
          sktMsg += this.sliderValue + '~';
          // sktMsg += '1' + '~';
          sktMsg += this.quantity + '~';
          sktMsg += this.recipientName + '~';
          sktMsg += this.recipientEmail + '~';
          sktMsg += this.giftMessage + '~';
          sktMsg += this.recieveEmailstatus + '~';
          sktMsg += this.versionType + '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += '~';
          sktMsg += this.personType + '~'; 
          sktMsg += this.salesDescription + '~';

          this.stMsg = sktMsg

          console.log("this.stMsg")
          console.log(this.stMsg)
          const payObj = {
            'line_items': {
              'name': this.buyersName,
              'email': this.buyersEmail,
              'phone': this.buyersPhone,
              'description': this.info.title,
              'club_logo': 'https://wp-ocssport.ocs-sport.com/simpark/wp-content/uploads/sites/5/2025/05/SimPark.png',
              'amount' : (feeUnit + feeCent),
              'currency': 'gbp',
              'quantity': 1,
            },
            'client_reference_id': JSON.stringify({user: 'VOUCHER'}),
            'customer_email': emailAddr,
            'success_url': 'https://ocs.golf/voucher-success/',
            'cancel_url': 'https://ocs.golf/voucher-fail/',
            'club_code': '2000029000',
            // 'club_code': '1000000001',
            'fac_mid': '0001',
            'fromweb': 'y',
            'book_string': this.stMsg,
            'book_string2': '',
            'payment_type': 'V',
          };

          if (typeof payOpts == 'object') {
            for (const i in payOpts)
              payObj[i] = payOpts[i];
          }

          return payObj
        }
				// const feeAmnt = parseFloat('1').toFixed(2).split('.');
      
		}, 
    getStripe() {
      // this.payWindow = window.open(
      //   'about:blank',
      //   'simpark_pay' 
      // );
      let sktMsg = this.payStripe()
      console.log("sktMsg")
      console.log(sktMsg)
      this.getSubscriped();
      this.getVoucherData();
      this.$socket.emit('paysession', sktMsg);
      // setInterval(this.$refs.formdata.reset(), 10000);
    },
    getStripeMob() {
      this.payWindow = window.open(
        'about:blank',
        'simpark_pay' 
      );
      let sktMsg = this.payStripe()
      console.log("sktMsg")
      console.log(sktMsg)
      this.getSubscripedMob();
      this.getVoucherData();
      this.$socket.emit('paysession', sktMsg);
      // setInterval(this.$refs.formdata.reset(), 10000);
    },
    getSubscriped : function() {
      this.sockets.subscribe('resppaysession', (data) => {
        this.urlData = data.url;
        this.statusData = data.status;
        // console.log("this.urlData")
        // console.log(this.urlData)
        window.open(
          this.urlData,
          '_blank' 
        );
        // this.payWindow.location = this.urlData
      })
    },
    getSubscripedMob : function() {
      this.sockets.subscribe('resppaysession', (data) => {
        this.urlData = data.url;
        this.statusData = data.status;
        // console.log("this.urlData")
        // console.log(this.urlData)
        // window.open(
        //   this.urlData,
        //   '_blank' 
        // );
        this.payWindow.location = this.urlData
      })
    },
    getVoucherData : function() {
      this.sockets.subscribe('respvoucher', (data) => {
        // console.log('respvoucher')
        // console.log(data)
        this.VData = data;
        console.log("this.VData")
        console.log(this.VData)
      })
    },
    sliderMoney : function() {
        if (this.golfInfo.length > 0) {
          this.info = this.golfInfo[0]
        } else if(this.raceInfo.length > 0) {
          this.info = this.raceInfo[0]
        }else if(this.flightInfo.length > 0) {
          this.info = this.flightInfo[0]
        }else if(this.simInfo.length > 0) {
          this.info = this.simInfo[0]
        }
    }
  },
  mounted() {
    axios //add API Call
        .get(
            process.env.VUE_APP_API_URL + 'simpark' + "/wp-json/wp/v2/pages/169"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.loading = true,
            this.acf = response.data,
            this.getvoucherContentGolf(),
            this.getvoucherContentFlight(),
            this.getvoucherContentRace(),
            this.sliderMoney(),
            this.loading = false
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
::v-deep .noUi-connects {
    border-radius: 3px;
    background: #f0efef;
}
button.submit.dis {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
p.my-4.voucherTextMain {
  color: black;
  font-size: 20px;
  font-style: italic;
  /* text-align: left; */
  /* padding-top: 15px; */
  font-family: "korolev", sans-serif;
  font-weight: 700;
  padding-top: 22px;
}
p.my-4.voucherText {
  color: black;
}
p.my-4.voucherCode {
  color: black;
  font-size: 55px;
  font-style: italic;
  /* text-align: left; */
  /* padding-top: 15px; */
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
p.my-4.voucherexpiry {
  color: black;
  font-size: 20px;
  font-style: italic;
  /* text-align: left; */
  /* padding-top: 15px; */
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
.voucherImage {
  width: 100%;
}
/* The Modal (background) */
.content {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  border-radius: 20px;
}

/* Modal Content */
.boxcontent {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  border-radius: 20px;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
strong {
  font-weight: bold;
  font-size: 27px !important;
}
.slider {
  /* overwrite slider styles */
  width: 100%;
}
::v-deep .range-slider-fill {
  background-color: #D80E1F!important;
}
::v-deep .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border: 1px solid #000000;
  border-radius: 50%;
  background-color: #000000;
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.moneyValue {
  /* padding-left: 18px; */
  /* color: #000; */
}
::v-deep .noUi-handle {
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #000000;
  cursor: default;
  box-shadow: none;
}
span.slidervalue {
  color: black;
  font-size: 18px;
  text-align: left;
  width: 100%;
  display: block;
  padding-bottom: 20px;
  /* margin-left: -15px; */
}
p.value {
  text-align: left;
  color: #242533;
  font-weight: 500;
  font-size: 18px;
  padding-top: 10px;
}
.slidecontainer {
  width: 100%;
}

/* .slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
} */

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #000000;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #000000;
  cursor: pointer;
}
.check.custom-control.custom-checkbox {
  padding-top: 30px;
  padding-bottom: 20px;
  text-align: left;
}
span.gift {
  text-align: left;
  color: #242533;
  font-weight: 500;
  font-size: 18px;
  padding-top: 10px;
}
.submit {
  height: 40px;
  color: #fff;
  background-color: #D80E1F;
  border-radius: 27px;
  border: none;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
}
.buttonSec {
  margin-top: 30px;
  margin-bottom: 100px;
}
::v-deep .form-group.mb-0.buyersName > label{
  padding-top: 0px;
}
.receipentSection {
  padding-top: 20px;
}
::v-deep .d-block {
  display: block !important;
  text-align: left;
  color: #242533;
  font-weight: 500;
  font-size: 18px;
  padding-top: 10px;
}
.SectionTitle {
  color: #242533;
  font-size: 32px;
  font-weight: bold;
  font-style: italic;
  text-align: left;
  font-family: "korolev", sans-serif;
  font-weight: 700;
}
.loading {
  color: #242533;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 100px;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #000000;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  margin-bottom: 20px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.backImage {
    height: 375px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
h2.titleText {
    color: #242533;
    font-size: 32px;
    font-weight: bold;
    font-style: italic;
    text-align: left;
    padding-bottom: 30px;
    padding-top: 50px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
}
h2.moneyValue {
    color: #242533;
    font-size: 32px;
    font-weight: bold;
    font-style: italic;
    text-align: left;
    padding-bottom: 30px;
    font-family: "korolev", sans-serif;
    font-weight: 700;
}
p.description {
    color: #242533;
    font-size: 20px;
    text-align: left;
    padding-bottom: 30px;
}
.title {
  color: black;
}
.ContactSection {
  /* background-color: #1A1A1A; */
}
.ContactTitle {
  color: #fff;
  font-size: 65px;
  padding-top: 80px;
  font-family: "korolev", sans-serif;
  font-weight: 700;
  font-style: italic;
}
.WhiteStandard-text {
  font-size: 24px;
  color: #fff;
  font-family: "noto-sans", sans-serif;
  font-weight: 400;
  font-style: normal;
}
.contact-width {
  width: 100%;
  text-align: center;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 70px;
}
@media only screen and (max-width: 768px) {
  .backImage.backImageCust {
    background-size: contain;
    height: 230px;
  }
  .ContactTitle {
    color: #fff;
    font-size: 40px;
  }
  .WhiteStandard-text {
    font-size: 20px;
    color: #fff;
    font-family: "noto-sans", sans-serif;
    font-weight: 400;
    font-style: normal;
  }
  .imagesInsert {
    width: 100%;
  }
}
</style>
